import { type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SectionEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

export default function SectionEmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
}: SectionEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-primary/60" />
      </div>
      <h3 className="text-base font-heading font-medium text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1.5 max-w-xs">{description}</p>
      <Button className="mt-5 gap-2" onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  );
}
